import { Link as RouterLink } from 'react-router-dom';
import { LandingNav } from '../../components/landing/LandingNav';
import { LandingFooter } from '../../components/landing/LandingFooter';
import { LandingCta } from '../../components/landing/LandingCta';
import { CookieConsent } from '../../components/common/CookieConsent';
import '../Landing.css';
import './Marketing.css';

interface MarketingLayoutProps {
  /** Path of the current page, excluded from the explore-more links. */
  current: string;
  children: React.ReactNode;
}

const exploreLinks = [
  { to: '/features/whatsapp', label: 'WhatsApp for Schools' },
  { to: '/features/fees', label: 'Fees Management' },
  { to: '/features/accounting', label: 'School Accounting' },
  { to: '/features/reports', label: 'Report Cards' },
  { to: '/features/ecocash-payments', label: 'EcoCash Payments' },
  { to: '/features/zimsec-exams', label: 'ZIMSEC Grading and Exams' },
  { to: '/secondary-schools', label: 'For Secondary Schools' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/faq', label: 'FAQ' },
  { to: '/about', label: 'About Us' },
];

/**
 * Shared shell for the prerendered SEO marketing pages (/pricing, /features/*).
 * Reuses the landing nav and footer so the pages feel like part of the main
 * site, and cross-links every marketing page for internal linking.
 */
export const MarketingLayout: React.FC<MarketingLayoutProps> = ({ current, children }) => (
  <>
    <LandingNav />

    <div className="landing-container mkt-page">
      {children}

      <section className="mkt-section mkt-explore">
        <div className="mkt-content">
          <h2 className="mkt-explore-title">Explore Rongeka Africa</h2>
          <div className="mkt-explore-links">
            {exploreLinks
              .filter((link) => link.to !== current)
              .map((link) => (
                <RouterLink key={link.to} to={link.to} className="mkt-explore-link">
                  {link.label}
                </RouterLink>
              ))}
          </div>
          <LandingCta />
        </div>
      </section>

      <LandingFooter />
      <CookieConsent />
    </div>
  </>
);
